
'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';
import flatpickr from 'flatpickr';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';

const $ = jQuery.noConflict();

$(function() {

	const contact = {

		init: function() {
			cf7Helpers.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 6000);
			cf7Helpers.scrollToFirstError('.js-cf7-holder', 120);
			contact.initSubmitState();
			contact.initDatepicker();
			contact.initFadeIn();
		},

		initSubmitState: function() {
			const holder = document.querySelector('.js-cf7-holder');
			if (!holder) {
				return;
			}

			const getSubmit = () => holder.querySelector('.wpcf7-submit');

			document.addEventListener('wpcf7beforesubmit', () => {
				const btn = getSubmit();
				if (btn) {
					btn.disabled = true;
				}
			}, false);

			const enableSubmit = () => {
				const btn = getSubmit();
				if (btn) {
					btn.disabled = false;
				}
			};

			document.addEventListener('wpcf7mailsent', enableSubmit, false);
			document.addEventListener('wpcf7invalid', enableSubmit, false);
			document.addEventListener('wpcf7mailfailed', enableSubmit, false);
			document.addEventListener('wpcf7spam', enableSubmit, false);
		},

		initFadeIn: function() {
			const targets = document.querySelectorAll('.js-contact-fade');
			if (!targets.length || !('IntersectionObserver' in window)) {
				targets.forEach((el) => el.classList.add('is-visible'));
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-visible');
						observer.unobserve(entry.target);
					}
				});
			}, {threshold: 0});

			targets.forEach((el) => observer.observe(el));
		},

		initDatepicker: function() {
			// target by class (from CF7 shortcode) or by id as fallback
			const targets = document.querySelectorAll('.js-month-year-picker, #move-in-date');
			if (!targets.length) {
				return;
			}

			targets.forEach((el) => {
				flatpickr(el, {
					plugins: [
						new monthSelectPlugin({shorthand: false, dateFormat: 'F Y', altFormat: 'F Y'})
					],
					disableMobile: true,
				});
			});
		},
	};

	contact.init();
});
